<!-- eslint-disable no-irregular-whitespace -->
<template>
    <div class="container">
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                <h1 class="title">RGPD</h1>
                <h2 class="subtitle">Vie privée</h2>
                </div>
            </div>
        </section>
        <div class="box">
            <div class="space-under">
                En sa qualité de responsable de traitement, Arewal SC dont le siège social est situé Rue des Marais 11
                à Andenne, recueille vos données personnelles afin de vous permettre d’accéder à la plateforme
                MyConso.
            </div>

            <div class="space-under">
                Les données que vous fournissez sur la page dédiée MyConso sont nécessaires pour vous permettre
                d’accéder à celle-ci. Les traitements relatifs à ces données ont pour finalités : <br>
                De vérifier votre identité de manière sécurisée pour accéder à la plateforme MyConso (La Base légale
                de ce traitement est l’intérêt légitime de AREWAL (Cf. article 6.1.f ) du RGPD). <br>
                De vous permettre d’accéder à vos données personnelles en renseignant vos : Nom, Prénom, Email,
                Numéro de téléphone, Rue, Code postal et Localité, EAN, numéro de compteur, Login et Mode de
                passe) de les modifier ou les compléter (La base légale de ce traitement est le consentement (Cf.
                article 6.1.a du RGPD). <br>
                De vous permettre de prendre connaissance de vos informations liées à votre compteur telles que
                votre numéro EAN, votre dernier relevé d’index, votre consommation ou encore vos historiques de
                consommations (La base légale de ce traitement peut être l’intérêt légitime de AREWAL (Cf. article
                6.1.f du RGPD) ou le respect d’une obligation légale ou règlementaire (Cf. article 6.1.c du RGPD)).
                Les destinataires des données personnelles de la plateforme « MyConso » sont les services Clients,
                Comptable et IT de votre gestionnaire de réseau, le service exploitation et les sous-traitants qui sont
                chargés de la livraison des prestations de raccordement au réseau.
            </div>

            <div class="space-under">Pour de plus amples informations au sujet des traitements, des finalités et des destinataires de vos
            données, nous vous invitons à consulter la politique vie privée de votre gestionnaire de réseau.</div>

            <div class="space-under">Arewal conserve vos données personnelles pour les gestionnaires de réseau AIEG, AIESH et REW pour
            la plus longue des durées nécessaires au respect des dispositions légales et réglementaires
            applicables ou pour une autre durée justifiée par des contraintes opérationnelles telles qu’une bonne
            tenue de la comptabilité, un management efficace et les réponses aux demandes en justice ou du
            régulateur.
            </div>

            <div class="space-under">Les données personnelles recueillies par le biais de la plateforme « MyConso » sont conservées
            pendant un délai de trente-six mois à compter de la date à partir de laquelle une communication est
            possible pour la dernière fois à l’aide du service utilisé.
            À l'expiration de ce délai de trente-six mois, les données de mesure (index et consommations) collectées via la plateforme « MyConso » sont automatiquement supprimées, selon le principe de la fenêtre glissante : seules les données de mesure des trente-six derniers mois sont conservées à tout moment, les données plus anciennes étant effacées au fur et à mesure, sauf obligation légale ou réglementaire imposant à Arewal SC de les conserver plus longtemps. Cette suppression intervient conformément à l'article 5.1.e) du RGPD, qui impose que les données à caractère personnel ne soient conservées que pendant la durée nécessaire aux finalités pour lesquelles elles sont traitées.
            </div>

            <div class="space-under">Vous bénéficiez d’un droit d’accès, de rectification et de suppression de vos données dans les limites
            prévues par les textes législatifs et les règlements. Vous pouvez également vous opposer, pour un
            motif légitime, à l’utilisation de vos données lorsque la législation le permet.</div>

            <div class="space-under">Vous pouvez exercer ces droits auprès du Délégué à la protection des données en vous adressant au
            « DPO Office » de votre gestionnaire de réseau par e-mail à l’adresse <br>
            - DPO@aieg.be pour l’AIEG <br>
            - protection.donnees@grdwavre.be pour le REW <br>
            - dpo@aiesh.be pour l’AIESH <br>
            en joignant la copie de votre justificatif d’identité (recto de la carte uniquement). Enfin, vous avez le
            droit d’introduire une réclamation auprès de l’Autorité de la protection des données.</div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style>
.space-under {
    margin-bottom: 2rem;
}
</style>